import React from "react";
import { ActivityModule, Modules } from "../../../constants/Module";
import { ucFirst } from "../../../helpers/string_helper";
import { Action } from "../../../constants/Common";
import ArrowRightAltOutlinedIcon from "@mui/icons-material/ArrowRightAltOutlined";
import CreatorDetails from "./creatorDetails";
import dayjs from "dayjs";
import { withTranslation } from "react-i18next";

const ProjectActivity = ({ item, t }) => {
    return (
        <React.Fragment>
            <div className="mx-2">
                {item?.module === ActivityModule.CHANGE_REQUEST_ITEM && (
                    <div>
                        <strong> {ucFirst(Modules.PROJECT)} ({item.payload?.project.name}) </strong> {t('was updated to')} <strong>{t('change request')} ({item.payload?.changeRequest?.uniqueChangeRequestId})</strong>
                        <CreatorDetails creator={item?.creator} date={item?.createdAt} />
                    </div>
                )}
                {item?.module === ActivityModule.PROJECT &&
                    <div>
                        <strong> {ucFirst(Modules.PROJECT)} ({item?.project?.uniqueProjectId}) </strong>
                        {t('was updated from')} <strong>{t('change request')} ({item.payload?.changeRequest?.uniqueChangeRequestId})</strong>
                        <CreatorDetails creator={item?.creator} date={item?.createdAt} />
                    </div>
                }
                {item?.payload?.event === Action.UPDATE &&
                    <div key={item?.id}>
                        {item.payload?.payload?.scope &&
                            item.payload?.payload?.scope?.old &&
                            item.payload?.payload?.scope?.new && (
                                <div className="mx-2">
                                    <div className="d-flex align-items-center change_status">
                                    <strong> {t('with scope') + ":"}</strong>
                                        <div className="d-flex align-items-center mx-2">
                                        <span>{item.payload?.payload?.scope?.old}</span>
                                        </div>
                                        <span className="middleArrow mx-2">
                                            <ArrowRightAltOutlinedIcon />
                                        </span>
                                        <div className="d-flex align-items-center">
                                            <span className="mx-2">
                                            {item.payload?.payload?.scope?.new}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        {item.payload?.payload?.projectCost &&
                            item?.payload?.payload?.projectCost?.old &&
                            item?.payload?.payload?.projectCost?.new && (
                                <div className="mx-2">
                                    <div className="d-flex align-items-center change_status">
                                    <strong> {t('with project cost') + ":"}</strong>
                                        <div className="d-flex align-items-center mx-2">
                                        <span>{parseFloat(item.payload?.payload?.projectCost?.old).toFixed(2)}</span>
                                        </div>
                                        <span className="middleArrow mx-2">
                                            <ArrowRightAltOutlinedIcon />
                                        </span>
                                        <div className="d-flex align-items-center">
                                            <span className="mx-2">
                                            {parseFloat(item?.payload?.payload?.projectCost?.new).toFixed(2)}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        {item.payload?.payload?.schedule?.endDate &&
                            item.payload?.payload?.schedule?.endDate?.old &&
                            item.payload?.payload?.schedule?.endDate?.new && (
                                <div className="mx-2">
                                    <div className="d-flex align-items-center change_status">
                                    <strong> {t('with end date') + ":"}</strong>
                                        <div className="d-flex align-items-center mx-2">
                                        <span>{item.payload?.payload?.schedule?.endDate?.old}</span>
                                        </div>
                                        <span className="middleArrow mx-2">
                                            <ArrowRightAltOutlinedIcon />
                                        </span>
                                        <div className="d-flex align-items-center">
                                            <span className="mx-2">
                                            {item.payload?.payload?.schedule?.endDate?.new}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        {item.payload?.payload?.schedule?.startDate &&
                            item.payload?.payload?.schedule?.startDate?.old &&
                            item.payload?.payload?.schedule?.startDate?.new && (
                                <div className="mx-2">
                                    <div className="d-flex align-items-center change_status">
                                    <strong> {t('with start date') + ":"}</strong>
                                        <div className="d-flex align-items-center mx-2">
                                        <span>{item.payload?.payload?.schedule?.startDate?.old}</span>
                                        </div>
                                        <span className="middleArrow mx-2">
                                            <ArrowRightAltOutlinedIcon />
                                        </span>
                                        <div className="d-flex align-items-center">
                                            <span className="mx-2">
                                            {item.payload?.payload?.schedule?.startDate?.new}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                    </div>
                }
                {item.module === ActivityModule.PROJECT && item.event === Action.UPDATE && (
                    <div key={item?.id}>
                        {item.payload?.scope &&
                            item.payload?.scope?.old &&
                            item.payload?.scope?.new && (
                                <div className="mx-2">
                                    <div className="d-flex align-items-center change_status">
                                        <strong> {t('with scope') + ":"}</strong>
                                        <div className="d-flex align-items-center mx-2">
                                            <span>{item.payload?.scope?.old}</span>
                                        </div>
                                        <span className="middleArrow mx-2">
                                            <ArrowRightAltOutlinedIcon />
                                        </span>
                                        <div className="d-flex align-items-center">
                                            <span className="mx-2">
                                                {item.payload?.scope?.new}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        {item.payload?.projectCost &&
                            item?.payload?.projectCost?.old &&
                            item?.payload?.projectCost?.new && (
                                <div className="mx-2">
                                    <div className="d-flex align-items-center change_status">
                                        <strong> {t('with project cost') + ":"}</strong>
                                        <div className="d-flex align-items-center mx-2">
                                            <span>{parseFloat(item.payload?.projectCost?.old).toFixed(2)}</span>
                                        </div>
                                        <span className="middleArrow mx-2">
                                            <ArrowRightAltOutlinedIcon />
                                        </span>
                                        <div className="d-flex align-items-center">
                                            <span className="mx-2">
                                                {parseFloat(item?.payload?.projectCost?.new).toFixed(2)}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        {item.payload?.endDate &&
                            item.payload?.endDate?.old &&
                            item.payload?.endDate?.new && (
                                <div className="mx-2">
                                    <div className="d-flex align-items-center change_status">
                                        <strong> {t('with end date') + ":"}</strong>
                                        <div className="d-flex align-items-center mx-2">
                                        <span>{dayjs(item.payload?.endDate?.old).format('YYYY-MM-DD')}</span>
                                        </div>
                                        <span className="middleArrow mx-2">
                                            <ArrowRightAltOutlinedIcon />
                                        </span>
                                        <div className="d-flex align-items-center">
                                            <span className="mx-2">
                                            {dayjs(item.payload?.endDate?.new).format('YYYY-MM-DD')}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        {item.payload?.startDate &&
                            item.payload?.startDate?.old &&
                            item.payload?.startDate?.new && (
                                <div className="mx-2">
                                    <div className="d-flex align-items-center change_status">
                                        <strong> {t('with start date') + ":"}</strong>
                                        <div className="d-flex align-items-center mx-2">
                                        <span>{dayjs(item.payload?.startDate?.old).format('YYYY-MM-DD')}</span>
                                        </div>
                                        <span className="middleArrow mx-2">
                                            <ArrowRightAltOutlinedIcon />
                                        </span>
                                        <div className="d-flex align-items-center">
                                            <span className="mx-2">
                                            {dayjs(item.payload?.startDate?.new).format('YYYY-MM-DD')}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                    </div>
                )}
            </div>
        </React.Fragment>
    )
}
export default withTranslation()(ProjectActivity);
